import { css } from "@emotion/react";

export const confirmModal = () => css`
  & > div:first-of-type > button:first-of-type {
    display: none;
  }
`;
